export default __webpack_public_path__ + "static/media/tempestofsetaction.81147741.png";